// extracted by mini-css-extract-plugin
module.exports = {"score-board-item":"item_score-board-item__3wpP3","symbol-size":"item_symbol-size__3pYRI","icon-mini":"item_icon-mini__1UJQl","icon-bet-history":"item_icon-bet-history__3sOZE"};